<adex-email-confirmation
  [email]="email$ | async"
></adex-email-confirmation>
